export default {"src":"/_next/static/media/carFullCircleBlue_40.cd011dca.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};